import React from 'react';

function Budgetestimator() {
    return (
        <div>
            Budgetestimator
        </div>
    )
}

export default Budgetestimator